import {
  IconEffectsColorCycle,
  IconInkDoubleDrops,
  IconPrinter,
  IconPrinterUpgrade,
  IconShieldCheckmark,
} from '@veneer/core';
import { ReactElement } from 'react';

interface HowYourPlanWorksCard {
  text: string;
  color: string;
  title: string;
  icon: string;
  name: string;
  list?: string[];
  extraContent?: string;
}

interface HowYourPlanWorksData {
  cards: HowYourPlanWorksCard[];
}

interface CardResult {
  text: string;
  color: string;
  title: string;
  icon: ReactElement | null;
  name: string;
  list?: string[];
  extraContent?: string;
}

function getIcon(iconName: string): ReactElement {
  switch (iconName) {
    case 'IconPrinter':
      return <IconPrinter size={60} color="gray12" />;
    case 'IconInkDoubleDrops':
      return <IconInkDoubleDrops size={60} color="gray12" />;
    case 'IconShieldCheckmark':
      return <IconShieldCheckmark size={60} color="gray12" />;
    case 'IconPrinterUpgrade':
      return <IconPrinterUpgrade size={60} color="gray12" />;
    case 'IconEffectsColorCycle':
      return <IconEffectsColorCycle size={60} color="gray12" />;
    default:
      return null;
  }
}

export const getCards = (howYourPlanWorks: HowYourPlanWorksData) => {
  const cards = howYourPlanWorks?.cards;

  return cards?.map(
    (item: HowYourPlanWorksCard): CardResult => ({
      text: item.text,
      color: item.color,
      title: item.title,
      icon: getIcon(item.icon),
      name: item.name,
      list: item?.list,
      extraContent: item?.extraContent,
    })
  );
};
